import { assert_string_object_id, assert_type_boolean } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { ERROR_GRAPH__base } from '../_errors/ERROR_GRAPH__base';
import { ENUM__generation_output_type } from '../_templates/_enums/ENUM__generation_output_type';

export class DTO_GRAPH_META__info extends DTO__base {
  /*
   * STATIC FIELDS
   */

  static _class_name_static = ENUM__dto_class_name.GRAPH_META;

  /*
   * FIELDS
   */
  graph_id!: string;

  errors!: ERROR_GRAPH__base[];
  is_validated!: boolean;
  //todo:remove
  name!: string;
  output_type!: ENUM__generation_output_type;

  /*
   * METHODS
   */

  constructor() {
    super();

    this.errors_clear();
  }

  errors_clear() {
    this.errors = [];
    this.is_validated = false;
  }

  assert_standard_fields(): void {
    assert_string_object_id(this.graph_id);
    assert_type_boolean(this.is_validated);
  }
}
